import { normalizeSourceUrl } from './notebook';
export function extractArticleUrls(text: string): string[] {
 const urls=new Set<string>();
 for (const value of text.match(/https?:\/\/[^\s<>"']+/gi) ?? []) { try { urls.add(normalizeSourceUrl(value.replace(/[),.!?;\]}>]+$/,''))); } catch { /* 주소 외 글은 저장하지 않아요. */ } }
 return [...urls].slice(0,30);
}
